import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PageLoader from "components/PageLoader";

const LazyAppointment = lazy(() => import('pages/Appointment'));
const LazyAppointmentDetail = lazy(() => import('pages/AppointmentDetail'));
const LazyAppointmentReschedule = lazy(() => import('pages/AppointmentReschedule'));
const LazyAppointmentReport = lazy(() => import('pages/AppointmentReport'));

function AppointmentRoute() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<LazyAppointment />} />
        <Route path="/report" element={<LazyAppointmentReport />} />
        <Route path="/:appointment_id" element={<LazyAppointmentDetail />} />
        <Route path="/:appointment_id/reschedule" element={<LazyAppointmentReschedule />} />
      </Routes>
    </Suspense>
  );
}

export default AppointmentRoute;
